import request from '@/config/axios'

export interface ShareholderUserVO {
  id?: number
  userId?: number
  nickname?: string
  avatar?: string
  mobile?: string
  levelId?: number
  levelName?: string
  status?: number
  applyTime?: string
  auditTime?: string
  auditReason?: string
  becomeTime?: string
  totalBonus?: number
  withdrawBonus?: number
  freezeBonus?: number
  createTime?: string
}

export const getShareholderUserPage = async (params: any) => {
  return await request.get({ url: '/trade/shareholder/user/page', params })
}

export const getShareholderUser = async (id: number) => {
  return await request.get({ url: '/trade/shareholder/user/get', params: { id } })
}

export const createShareholderUser = async (data: { userId: number; levelId?: number }) => {
  return await request.post({ url: '/trade/shareholder/user/create', data })
}

export const auditShareholderUser = async (data: {
  id: number
  approved: boolean
  auditReason?: string
}) => {
  return await request.put({ url: '/trade/shareholder/user/audit', data })
}

export const updateShareholderUserStatus = async (data: { id: number; status: number }) => {
  return await request.put({ url: '/trade/shareholder/user/update-status', data })
}

export const updateShareholderUserLevel = async (data: { id: number; levelId: number }) => {
  return await request.put({ url: '/trade/shareholder/user/update-level', data })
}

export const tryUpgradeShareholderUser = async (userId: number) => {
  return await request.post({ url: '/trade/shareholder/user/try-upgrade', params: { userId } })
}
